function IconHome({
  size = 24,
  color = '#1A1C1E',
  strokeWidth = 2.14286,
}: {
  size?: number;
  color?: string;
  strokeWidth?: number;
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
d="M9.5 16.4997V19.9997H6C4.89543 19.9997 4 19.1043 4 17.9997V10.0518C4 9.39316 4.32423 8.77678 4.86694 8.40367L10.8669 4.27867C11.5494 3.80945 12.4506 3.80945 13.1331 4.27867L19.1331 8.40367C19.6758 8.77678 20 9.39316 20 10.0518V17.9997C20 19.1043 19.1046 19.9997 18 19.9997H14.5V16.4997C14.5 15.119 13.3807 13.9997 12 13.9997C10.6193 13.9997 9.5 15.119 9.5 16.4997Z"
      />
    </svg>
  );
}

IconHome.displayName = 'IconHome';

export default IconHome;
